import { render, staticRenderFns } from "./myschoolinfo.vue?vue&type=template&id=e9a4090c&scoped=true&"
import script from "./myschoolinfo.vue?vue&type=script&lang=js&"
export * from "./myschoolinfo.vue?vue&type=script&lang=js&"
import style0 from "./myschoolinfo.vue?vue&type=style&index=0&id=e9a4090c&lang=scss&scoped=true&"
import style1 from "./myschoolinfo.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e9a4090c",
  null
  
)

export default component.exports